





















































import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {FORMAT_DATE_TIME_PICKER} from "@/shared/constant";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import moment from "moment";
import {numberToWord} from "@/shared/services/helper/number-to-vn";

@Component({
    name: "ManageCodCustomerExcel",
    components: {TooltipLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly id!: string;
    @Prop() readonly title!: string;
    @Prop() readonly billLadings!: any[];
    @Prop({ default: false }) readonly isViewPayed!: boolean;
    FORMAT_DATE_TIME_PICKER = FORMAT_DATE_TIME_PICKER;
    moment = moment;
    numberToWord = numberToWord;
}
